import React from 'react';
import { CloudflareLogo } from '@ui/components';
import { Container } from './styled';
import { ChoiceGroup, DefaultButton, IChoiceGroupOption, MessageBar, MessageBarType } from '@fluentui/react';
import sendEML from './functions';
import { AuthorizationContainer } from '../AuthorizationContainer';

const { API_ENDPOINT, PHISHNET_DEBUG_EMAIL } = (globalThis as unknown as Env);

export const SubmissionForm = () => {
  const submissionOptions: IChoiceGroupOption[] = [
    {
      key: 'spam',
      // @ts-ignore
      text: (
        <div>
          <b>Spam</b>
          <br />
          <span style={{ color: 'gray' }}>Unwanted random emails you wish to no longer receive</span>
        </div>
      ),
    },
    {
      key: 'malicious',
      // @ts-ignore
      text: (
        <div>
          <b>Phish</b>
          <br />
          <span style={{ color: 'gray' }}>
            Emails that are suspected to have malicious intent, including hack, scam & fraud
          </span>
        </div>
      ),
    },
    {
      key: 'bulk',
      // @ts-ignore
      text: (
        <div>
          <b>Bulk</b>
          <br />
          <span style={{ color: 'gray' }}>Unwanted marketing emails you wish to no longer receive</span>
        </div>
      ),
    },
  ];
  const [submissionType, setSubmissionType] = React.useState<IChoiceGroupOption>(submissionOptions[0]);
  const [errorMessage, setErrorMessage] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [submissionComplete, setSubmissionComplete] = React.useState(false);

  const onChangeSubmissionType = (_event: React.FormEvent<HTMLElement>, option: IChoiceGroupOption): void => {
    setSubmissionType(option);
  };

  const sendEmail = async (accessToken: string, retryEndpoint?: string) => {
    setErrorMessage(false);
    setLoading(true);

    const clientId = new URLSearchParams(window.location.search).get('clientId');
    const endpoint = retryEndpoint || `${API_ENDPOINT}/api/customers/submission_emails_by_office365_token?disposition=${submissionType.key}&office365_token=${clientId}`;

    try {
      let config: APIConfigurationResponse = { "submission_emails": [] }

      if (!PHISHNET_DEBUG_EMAIL) {
        const request = await fetch(endpoint);
        config = await request.json();
      } else {
        config.submission_emails = PHISHNET_DEBUG_EMAIL.split(",").map(email => email.trim())
      }

      const emails = config.submission_emails;

      for (const email in emails) {
        await sendEML({
          body: 'Raw eml file attached below',
          subject: `PhishNet Report: ${submissionType.key}`,
          to: emails[email],
          accessToken
        });
      }

      await new Promise((resolve) => {
        setTimeout(resolve, 3000);
      });

      setSubmissionComplete(true);
    } catch (e: any) {
      if (!retryEndpoint) {
        sendEmail(accessToken, endpoint + "=");
      } else {
        setErrorMessage(e.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AuthorizationContainer>
        {({ token }) =>
          <Container loading={loading}>
            <ChoiceGroup
              defaultSelectedKey={submissionType.key}
              options={submissionOptions}
              onChange={onChangeSubmissionType}
              label="Select Submission Type:"
              required
              disabled={loading || submissionComplete}
            />
            <DefaultButton disabled={loading || submissionComplete} onClick={() => sendEmail(token)}>
              {loading ? 'Loading...' : 'Submit Report'}
            </DefaultButton>
            {errorMessage && <MessageBar messageBarType={MessageBarType.error}>Error: {errorMessage}</MessageBar>}
            {submissionComplete && (
              <MessageBar messageBarType={MessageBarType.success}>
                Report Sent: You may select another email or close this panel.
              </MessageBar>
            )}
          </Container>
        }
      </AuthorizationContainer>
      <CloudflareLogo
        css={{
          width: '20vw',
          height: '20vw',
          padding: '2vw',
          position: 'absolute',
          bottom: '0px',
        }}
      />
    </>
  );
};
